// src/components/auth/AuthLayout.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.jpeg'; // Adjust path as needed

export default function AuthLayout({ children, title }) {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-brand-off-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div>
          <Link to="/">
            <img 
              className="mx-auto h-20 w-auto" 
              src={logo} 
              alt="Quality Air Houston"
            />
          </Link>
          {title && (
            <h2 className="mt-6 text-center text-3xl font-extrabold text-brand-text-dark">
              {title}
            </h2>
          )}
        </div>
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {children}
        </div>
      </div>
    </div>
  );
}
